<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center"> <b>Matricular Estudiantes</b> </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="text-primary text-center"> <b>Nombre: </b> {{parseModulo()}} </p>
          <form action="#" class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2"> Asunto: </label>
              <div class="col-sm-8"> <input type="email" class="form-control input-sm" v-model="asunto"> </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2"> Correo: </label>
              <div class="col-sm-8"> <input type="email" class="form-control input-sm" v-model="correo"> </div>
            </div>
          </form>

          <small class="text-info">Seleccione los estudiantes para inscribir en Moodle:</small>
          <p class="text-primary" style="margin-top:0"> <small>{{msg}}</small> </p>

          <div class="table-responsive">
            <button class="btn btn-link btn-sm" @click="selcheck(true)"> <span class="glyphicon glyphicon-check"></span> Todos</button>
            <button class="btn btn-link btn-sm" @click="selcheck(false)"> <span class="glyphicon glyphicon-unchecked"></span> Ninguno</button>
            <input type="text" placeholder="Buscar..." v-model="filter">
            <table class="table table-striped table-condensed table-hover" id="midatatableins">
              <thead>
                <tr>
                  <th> <small>Nro</small> </th>
                  <th style="min-width:350px!important"> <small>Estudiante</small> </th>
                  <th> <small>Fecha reg.</small> </th>
                  <th> <small>Moodle</small> </th>
                  <th> <small>Rol</small> </th>
                  <th> <small>Estado</small> </th>
                  <th style="width:85px;"> <small>Acciones</small> </th>
                </tr>
              </thead>
              <tbody>
                <tr :key="ind" v-for="(e,ind) in datos">
                  <td> <small> {{ind+1}} </small> </td>
                  <td> <small> <input type="checkbox" v-model="e.check"> {{e.nombre}} </small> </td>
                  <td style="min-width:80px"> <small> {{e.fecha_reg}}</small> </td>
                  <td> <small> {{e.umoodle}} </small> </td>
                  <td>
                    <select class="form-control" v-model.number="e.role">
                      <option value="3">PROFESOR CON PERMISO DE EDICION</option>
                      <option value="4">PROFESOR</option>
                      <option value="5">ESTUDIANTE</option>
                    </select>
                  </td>
                  <td> 
                    <div v-if="e.estado=='2'" class="loader"></div> 
                    <small v-else> {{e.estado}} </small>
                  </td>
                  <td>
                    <button class="btn btn-link btn-sm" @click="regMoodle(e)" title="Registrar antes de matricular"> <span class="glyphicon glyphicon-user"></span> </button>
                    <button class="btn btn-link btn-sm" @click="registrarUnito(e)" title="Matricular a este Estudiante"> <span class="glyphicon glyphicon-edit"></span> </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <Alertas 
          ref="alertar" 
          v-bind:msgSuccess="'El cambio de estado se realizo satisfactoriamente.'"
          v-bind:msgLoading="'Aplicando...'"
        />
        <div class="modal-footer">
          <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Matricular Seleccionados</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid blue; /* Blue */
  border-bottom: 4px solid blue;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1.2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<script>
import Alertas from '@/components/AAlertas.vue'

export default {
  props:{ modulo:{type:Object,required:true},xprograma:{type:Object,required:true} },// {pid,ccid,tag}
  data(){
    return{
      asunto:'Inscripcion Moodle',
      correo:'',
      timeoutHnd: 0,
      filter: null,
      activo:true,
      isLoading: false,
      categoria:{},
      datos:[],
      msg:'',
    }
  },
  components:{ Alertas },
  watch:{ 'filter':function(){ this.myFunction1(this.filter) } },
  methods:{
    parseLabel( opt ){ return opt.nombre },
    parseModulo(){
      if( this.modulo.tag ) return this.modulo.tag.modulo.nombre
      else "";
    },
    parseFecha( f ){
      var date = new Date( f );
      var a = date.getFullYear();
      var m = date.getMonth()+1;
      var d = date.getDate();
      if( m < 10 ) m = '0'+m;
      if( d < 10 ) d = '0'+d;
      return d+'-'+m+'-'+a;
    },
    moodleRegUnito(){},
    registrarUnito( e ){
      var rgs = [];
      e.estado = 2;
      rgs.push( {username:e.umoodle,courseId:this.modulo.tag.course_id,role:e.role} );
      this.registrar( rgs )
    },
    submit(){
      var vue = this;
      var rgs = [];
      this.datos.forEach(function(e){
        if( e.check ) {
          e.estado = 2;
          rgs.push( {username:e.umoodle,courseId:vue.modulo.tag.course_id,role:e.role} );
        }
      })
      this.registrar( rgs )
    },
    selcheck( estado ){
      this.datos.forEach(function(e){
        e.check = estado;
      })
    },
    registrar( enrollments ) {
      if( this.isLoading ) return;
      var vue = this;
      vue.isLoading = true;

      var cuerpo = {
        "data":{
          "attendant":{
            "name": this.asunto,
            "mail": this.correo
          },
          "enrollments":enrollments
        }
      };
      var data = JSON.stringify(cuerpo);
      var url = process.env.VUE_APP_URL_NOTIFIER_ESAM+"enrol-students-notification/";
      window.console.log( "DATA> ",data );

      var config = { method: 'post', url: url,headers: { 'Content-Type': 'application/json' }, data : data };
      window.axios(config)
        .then(function (res) {
          var data = res.data;
          // window.console.log('------------ RESPUESTA DEL SERVIDOR ------------')
          // window.console.log( ">> ",window.stringifyObject(data) )
          vue.isLoading = false;
          vue.msg = "";
          data.moodle.forEach( function(e){
            var est = vue.datos.find( x => e.includes(x.umoodle) );
            if( est ) est.estado = e;
            else est.estado = "?";
          });
          //estudiante.estado = data.moodle+', '+data.mail;
        })
        .catch(function (error) {
          window.console.error(error)
          vue.isLoading = false;
          vue.msg = "";
      });
    },
    setEstudiantes(){
      //window.console.log( "KKKKKKKKKKKKKKKKKKKKKKKKKK" )
      this.datos = [];
      var dts = [];
      var vue = this;
      this.xprograma.inscripciones.forEach( function(e){
        var nom = e.estudiante.nombres+' '+e.estudiante.pri_apellido;
        if( e.estudiante.seg_apellido ) nom += ' '+e.estudiante.seg_apellido;
        var fr = vue.parseFecha( e.estudiante.fecha_reg );
        dts.push( {id:e.estudiante.id,nombre:nom,umoodle:e.estudiante.usuario_moodle,fecha_reg:fr,estado:null,check:false,role:5} );
      })
      dts.sort(function(a, b){return (a.fecha_reg < b.fecha_reg)?1:-1});
      this.datos = dts;

      if( !this.xprograma.sede.correos ){
        this.activo = false;
        this.$refs.alertar.invalido("ERROR: la sede no tiene correo."); 
      }else{
        var cor = this.xprograma.sede.correos.find( x => x.tipo == 0 );
        // window.console.log( "MODALL ",cor ); 
        if( cor ) {
          this.correo = cor.direccion;
        }
        else{
          this.activo = false;
          this.$refs.alertar.invalido("ERROR: la sede no tiene correo del tipo 0 (corporativo)."); 
        }
      }
    },

    regMoodle( p ){
      var est = this.xprograma.inscripciones.find( x => x.estudiante.id == p.id ).estudiante;
      var ob = {
        usuario_moodle: est.usuario_moodle,
        clave_moodle: est.clave_moodle,
        nombres: est.nombres,
        pri_apellido: est.pri_apellido,
        seg_apellido: est.seg_apellido,
        email: est.email,
        telefono1: est.telefono1,
      }
      window.console.log( ob )
      p.estado = '2';
      this.registrarMoodle( this.correo,ob,p )
    },

    registrarMoodle(email,obj,student){
      var correo = {
        "data":{
          "attendant":{ "name": "Registro Estudiante Moodle", "mail": email },
          "student":{
            "username": obj.usuario_moodle,
            "password": obj.clave_moodle,
            "firstname": obj.nombres,
            "lastname": obj.pri_apellido+' '+obj.seg_apellido,
            "email": obj.email,
            "phone": obj.telefono1,
          }
        }
      }
      var data = JSON.stringify(correo);
      window.console.log( "CORREITO> ",data )
      var url = process.env.VUE_APP_URL_NOTIFIER_ESAM+'create-student-notification';
      if( obj.update ) url = process.env.VUE_APP_URL_NOTIFIER_ESAM+'update-student-notification'

      var config = {
        method: 'post',
        url: url,
        headers: { 
          'Content-Type': 'application/json'
        },
        data : data
      };

      window.axios(config)
        .then(function (res) {
          // window.console.log('----------- RESPUESTA DEL SERVIDOR REG MOODLE ----------------')
          const data = res.data
          window.console.log(res,data)
          student.estado = data.moodle;
        })
        .catch(function (error) {
          window.console.error('Registro Moodle ERROR: ',error)
          student.estado = error;
      });
    },

    myFunction1( filtro ) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd,td, i,j, txtValue;
        table = document.getElementById("midatatableins");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName("td");
          for(j = 1; j< tdd.length;j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = "";
                break;
              } else {
                tr[i].style.display = "none";
              }
            } 
          }
        }
      }
  },
  mounted(){
    var vue = this;
    window.$('#modal-modulo-inscribir').on('show.bs.modal', function () {
      vue.setEstudiantes();
    })

    const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
      const comparer = (idx, asc) => (a, b) => ((v1, v2) => v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2))(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));
      document.querySelectorAll('th').forEach(th => th.addEventListener('click', (() => {
          const table = th.closest('table');
          const tbody = table.querySelector('tbody');
          Array.from(tbody.querySelectorAll('tr'))
            .sort(comparer(Array.from(th.parentNode.children).indexOf(th), this.asc = !this.asc))
            .forEach((tr,ind) => {tr.firstChild.innerHTML=ind+1;tbody.appendChild(tr)} );
      })));
  }
}
</script>